<template>
  <div class="countries-regions-profile main-wrap full-width">
<!--    <div class="header-area flex flex-nowrap items-center hide-for-print">-->
<!--      &lt;!&ndash; <TourButton class="flex-none" @clicked="openTour(true)"></TourButton> &ndash;&gt;-->
<!--&lt;!&ndash;      <div v-if="$store.state.covid19.last_updated" class="last-updated flex-auto text-sm">Updated {{ $store.state.covid19.last_updated }}</div>&ndash;&gt;-->
<!--    </div>-->

    <transition name="fade">
      <InfoOverlay
        class="infoOverlay"
        v-if="!firstCountry"
        :description="this.$Strings('chooseACountry')"
      ></InfoOverlay>
    </transition>

    <div class="viewmode-chart" v-if="viewmode === 'chart'">
      <PreloaderOverlay v-if="$store.state.fetching.length > 0"></PreloaderOverlay>

      <header class="page-title__header" :class="{ isSmall : $store.state.covid19.is_enabled }">
        <h1 class="page-title" v-if="countries.length < 2 || $store.state.covid19.is_enabled">{{ firstCountry ? firstCountry.name : '&nbsp;' }}<span class="font-small font-sans-serif" v-if="$store.state.covid19.is_enabled && firstCountry">&nbsp;(COVID-19)</span></h1>
        <h1 class="page-title" v-else>{{ this.$Strings('countryComparisons') }}</h1>

        <div class="actions-wrap hide-for-print" v-if="!$store.state.covid19.is_enabled">

          <div class="actions btn-group mt-10" v-if="countries && countries.length <= 1">
            <a v-show="!(firstCountry && firstCountry.name === 'World') && !(firstCountry && firstCountry.name === 'German Democratic Republic')" :href="downloadProfileUrl" class="btn btn--fluid" target="_blank" id="download-btn">
              <span class="btn-content">
                <span class="btn-content__icon"><svg class="btn-content__icon__svg download-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10.5"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="downloadshare"><path class="cls-1" d="M9.66,5,6.56,7.54a.09.09,0,0,1-.11,0L3.34,5"/><line class="cls-1" x1="6.5" y1="7.77" x2="6.5"/><line class="cls-1" y1="10" x2="13" y2="10"/></g></g></g></svg></span>
                <span class="btn-content__value">{{ this.$Strings('downloadProfile') }}</span>
              </span>
            </a>
            <div @click.prevent.stop="gotoGlobalPerformance()" class="btn btn--fluid" target="_blank" id="global-performance-btn">
              <span class="btn-content">
                <span class="btn-content__icon"><svg class="btn-content__icon__svg global-performance-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.57 15.57"><circle class="cls-1" cx="7.79" cy="7.79" r="7.29"/><path class="cls-1" d="M15.13,8h-7a1.72,1.72,0,0,0-1.58,1h0A1.72,1.72,0,0,0,8.12,11.5h.63v3.83" transform="translate(-0.05 -0.26)"/><path class="cls-1" d="M8.94.84v3a1.59,1.59,0,0,0,1.59,1.59h4.11" transform="translate(-0.05 -0.26)"/><path class="cls-1" d="M3.48,2.22V5.14A1.88,1.88,0,0,1,1.6,7h-1" transform="translate(-0.05 -0.26)"/></svg></span>
                <span class="btn-content__value">{{ this.$Strings('compareToRegion') }}</span>
              </span>
            </div>
            <div @click.prevent.stop="gotoKeyAttributesOverTime()" class="btn btn--fluid" target="_blank" id="key-attributes-btn">
              <span class="btn-content">
                <span class="btn-content__icon"><svg class="btn-content__icon__svg key-attributes-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.8 12.02"><path class="cls-1" d="M3.6,8.37,6.9,6a1,1,0,0,1,.87-.15l3.74,1.11a.72.72,0,0,0,.62-.09l4.73-3.1" transform="translate(-0.33 -0.18)"/><path class="cls-1" d="M17.07,11.69h-16a.28.28,0,0,1-.28-.28V.18" transform="translate(-0.33 -0.18)"/></svg></span>
                <span class="btn-content__value">{{ this.$Strings('keyAttributesOverTime') }}</span>
              </span>
            </div>
          </div>

        </div>
      </header>

      <covid19-profile
        v-if="subattributeData && $store.state.covid19.is_enabled"
        :subattributeData="subattributeData"
        :subcomponentData="subcomponentData"
        :currentCountryDataset="currentCountryDataset"
        :firstCountry="firstCountry"
        :worldData="worldData"
      ></covid19-profile>

      <single-country
        v-if="subattributeData && subattributeData.length === 1 && !$store.state.covid19.is_enabled"
        :subattributeData="subattributeData"
        :subcomponentData="subcomponentData"
        :currentCountryDataset="currentCountryDataset"
        :firstCountry="firstCountry"
        :worldData="worldData"
      ></single-country>

      <multiple-countries
        v-if="subattributeData && subattributeData.length > 1 && !$store.state.covid19.is_enabled"
        :subattributeData="subattributeData"
        :attributeData="attributeData"
      >
      </multiple-countries>
    </div>

    <ViewModeTable :showAttributes="mainAttributeKeys.concat(subAttributeKeys)" v-if="viewmode === 'table'" :data="tableData" :dateRange="this.year"></ViewModeTable>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

import SingleCountry from './CountriesRegionsProfile/SingleCountry.vue'
import Covid19Profile from './../covid19/Covid19Profile.vue'
import MultipleCountries from './CountriesRegionsProfile/MultipleCountries.vue'

import PreloaderOverlay from '../shared/misc/PreloaderOverlay.vue'
import InfoOverlay from '../shared/misc/InfoOverlay.vue'

import ViewModeTable from './ViewModeTable'
import TourButton from '../tour/tourButton'

import {EventBus} from '@/event-bus.js'

export default {
  name: 'countries-regions-profile',
  components: {
    MultipleCountries,
    SingleCountry,
    TourButton,
    ViewModeTable,
    PreloaderOverlay,
    InfoOverlay,
    Covid19Profile
  },
  created () {
    if (this.$route.query.covid19 === '1') {
      this.$store.state.covid19.is_enabled = true
    } else {
      this.$store.state.covid19.is_enabled = false
    }
  },
  mounted () {
    EventBus.$emit('sidebar-nav', 'CountryRegionProfile')
    this.calculateSubattributeData()
    this.calculateSubcomponentData()
    this.fetchData()

    this.$nextTick(this.openTour)
    this.setCovid19FilterVisibility()
  },
  destroyed () {
    this.$store.state.covid19.filter_available = false
  },
  data () {
    return {
      CancelToken: axios.CancelToken,
      cancel () {},
      chartData: [],
      organizations: ['ASEAN', 'AU', 'EU', 'OAS', 'OECD'],
      subcomponentData: [],
      subattributeData: [],
      mainAttributeKeys: ['A_01', 'A_02', 'A_03', 'A_04'],
      subAttributeKeys: ['SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04', 'SA_02_01', 'SA_02_02', 'SA_02_03', 'SA_03_01', 'SA_03_02', 'SA_03_03', 'SA_04_01', 'SA_04_02', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04'],
      subComponentKeys: ['SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c']
    }
  },
  computed: {
    /**
     * AttributeData
     */
    attributeData () {
      let result = []
      _.each(this.countries, (country) => {
        let row = _.find(this.chartData, ['ID_country_name', country.name])
        let resultRow = []
        _.each(this.mainAttributeKeys, (columnKey) => {
          if (row) {
            resultRow.push(this.getRowData(row, columnKey))
          } else {
            resultRow.push(this.getEmptyRowData(country.name, columnKey))
          }
        })
        result.push(resultRow)
      })
      return result
    },

    /**
     * Returns the world data
     */
    worldData () {
      return _.find(this.chartData, ['ID_country_code', '999'])
    },

    /**
     * Gets the attributes for the table viewmode
     * @return {obj} Collection of results
     */
    tableData () {
      return this.chartData
    },

    /**
     * The download PDF profil URL
     * @return {string}
     */
    downloadProfileUrl () {
      let country = this.firstCountry
      if (country) {
        let type = (this.organizations.indexOf(country.name) === -1) ? country.type : 'organization'
        let slug = country.name.toLowerCase().replace(new RegExp(' ', 'g'), '-').replace(/[^a-zA-Z0-9._-]+/g, '')
        return process.env.PDF_URL + type + '/' + slug + '.pdf'
      }
    },
    viewmode () {
      return this.$store.state.viewMode
    },
    year () {
      return this.$store.state.yearSliderCurrent
    },
    countries () {
      return this.$store.state.rsc.selected
    },
    mainAttributes () {
      let result = []
      _.each(this.mainAttributeKeys, (columnKey) => {
        let attr = this.$store.getters['attributes/getLabelFromKey'](columnKey)
        if (attr) {
          result.push(attr)
        }
      })
      return result
    },
    firstCountry () {
      return this.$store.getters['rsc/firstSelected']
    }
  },
  watch: {
    firstCountry () {
      EventBus.$emit('slider.refresh')
    },
    subcomponentData () {
      EventBus.$emit('slider.refresh')
    },
    subattributeData () {
      EventBus.$emit('slider.refresh')
    },
    year () {
      this.fetchData()
    },
    countries () {
      this.setCovid19FilterVisibility()
      this.fetchData()
    }
  },
  methods: {
    setCovid19FilterVisibility () {
      this.$store.state.covid19.filter_available = true
    },
    currentCountryDataset () {
      if (this.chartData && this.firstCountry && this.firstCountry.id) {
        let id = '' + this.firstCountry.id + ''
        let result = _.find(this.chartData, ['ID_country_code', id])
        return result || {}
      }
      return {}
    },
    openTour (forceOpen) {
      let tourpages = []
      tourpages.push({
        title: this.$Strings('tour_profile1_title'),
        content: this.$Strings('tour_profile1_description'),
        elementId: false
      })

      tourpages.push({
        title: this.$Strings('tour_profile2_title'),
        content: this.$Strings('tour_profile2_description'),
        elementId: 'countries-nav'
      })

      // Remove tour information page on covid19 pages
      if (!this.$store.state.covid19.is_enabled) {
        tourpages.push({
          title: this.$Strings('tour_profile3_title'),
          content: this.$Strings('tour_profile3_description'),
          elementId: 'range-year-slider',
          style: {
            marginTop: '180px'
          }
        })

        tourpages.push({
          title: this.$Strings('tour_profile4_title'),
          content: this.$Strings('tour_profile4_description'),
          elementId: 'global-performance-btn'
        })
        tourpages.push({
          title: this.$Strings('tour_profile5_title'),
          content: this.$Strings('tour_profile5_description'),
          elementId: 'key-attributes-btn'
        })
        tourpages.push({
          title: this.$Strings('tour_profile6_title'),
          content: this.$Strings('tour_profile6_description'),
          elementId: 'download-btn'
        })
      }

      EventBus.$emit('tour:open', 'compare-region-profile', forceOpen, tourpages)
    },
    /**
     * Execute print
     * @return {string}
     */
    downloadDisplayedDataUrl () {
      window.print()
    },

    calculateSubcomponentData () {
      let result = []
      let countries = this.countries

      // Set dummy content
      // for no countries
      if (countries.length === 0) {
        countries = [{
          name: 'No country'
        }]
      }

      // There might be situations where
      // Countries has been selected - but no data
      // is retrieved from the selected year
      // ex German Democratic Republic in 2000
      // So we check how many rows are expected
      // and return a result indicating that
      // there is no data to be found
      _.each(countries, (country) => {
        let row = _.find(this.chartData, ['ID_country_name', country.name])
        let resultRow = []
        _.each(this.subComponentKeys, (columnKey) => {
          if (row) {
            resultRow.push(this.getRowData(row, columnKey))
          } else {
            resultRow.push(this.getEmptyRowData(country.name, columnKey))
          }
        })
        result.push(resultRow)
      })

      this.subcomponentData = result
    },

    calculateSubattributeData () {
      let result = []
      let countries = this.countries

      // Set dummy content
      // for no countries
      if (countries.length === 0) {
        countries = [{
          name: 'No country'
        }]
      }

      // There might be situations where
      // Countries has been selected - but no data
      // is retrieved from the selected year
      // ex German Democratic Republic in 2000
      // So we check how many rows are expected
      // and return a result indicating that
      // there is no data to be found
      _.each(countries, (country) => {
        let row = _.find(this.chartData, ['ID_country_name', country.name])
        let resultRow = []
        _.each(this.subAttributeKeys, (columnKey) => {
          if (row) {
            resultRow.push(this.getRowData(row, columnKey))
          } else {
            resultRow.push(this.getEmptyRowData(country.name, columnKey))
          }
        })
        result.push(resultRow)
      })

      this.subattributeData = result
    },

    gotoGlobalPerformance () {
      let selected = this.firstCountry
      let region = this.$store.getters['rsc/getCountryRegion'](selected.id)
      let subregion = this.$store.getters['rsc/getCountrySubregion'](selected.id)
      let world = this.$store.getters['rsc/getGlobal']

      this.$store.commit('rsc/resetAllSelected')

      this.$store.state.rsc.selected.push(selected)

      if (this.$store.state.rsc.regionsWithoutSubregions.indexOf(region.id) === -1 && subregion) {
        this.$store.state.rsc.selected.push(subregion)
      }

      if (this.$store.state.rsc.notSelectableRegions.indexOf(region.id) === -1 && region) {
        this.$store.state.rsc.selected.push(region)
      }

      if (selected.name !== 'World' && world) {
        this.$store.state.rsc.selected.push(world)
      }
    },

    gotoKeyAttributesOverTime () {
      let selected = this.firstCountry
      let region = this.$store.getters['rsc/getCountryRegion'](selected.id)
      let subregion = this.$store.getters['rsc/getCountrySubregion'](selected.id)
      let world = this.$store.getters['rsc/getGlobal']

      let countryselection = '[' + selected.id

      if (this.$store.state.rsc.regionsWithoutSubregions.indexOf(region.id) === -1 && subregion) {
        countryselection += ',' + subregion.id
      }

      if (this.$store.state.rsc.notSelectableRegions.indexOf(region.id) === -1 && region) {
        countryselection += ',' + region.id
      }

      if (selected.name !== 'World' && world) {
        countryselection += ',' + world.id
      }

      countryselection += ']'

      if (selected) {
        this.$router.push({ name: 'compare-countries-regions', query: { rsc: [countryselection], attr: ['["A_01"]'] } })
      }
    },

    getEmptyRowData (countryname, columnKey) {
      let rowData = { range: [] }
      rowData.columnKey = false
      rowData.range[0] = false
      rowData.range[1] = false
      rowData.value = false
      rowData.country = countryname
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name')
      rowData.color = 'gray-lighter'
      rowData.description = false
      return rowData
    },

    getRowData (row, columnKey) {
      let rowData = { range: [] }
      rowData.columnKey = columnKey
      rowData.range[0] = row[columnKey + '_L'] ? row[columnKey + '_L'] : false
      rowData.range[1] = row[columnKey + '_U'] ? row[columnKey + '_U'] : false
      rowData.value = row[columnKey] || false
      rowData.country = row['ID_country_name']
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name')
      rowData.color = this.$store.getters['attributes/labelInfo'](columnKey, 'color')
      rowData.description = this.$store.getters['attributes/labelInfo'](columnKey, 'description')
      return rowData
    },

    getAttributeValue (columnKey, value) {
      let row = this.currentCountryDataset()
      let data = !row ? this.getEmptyRowData('', columnKey) : this.getRowData(row, columnKey)
      return data[value] ? data[value] : undefined
    },

    /**
     * Load the profile data
     */
    loadProfileData () {
      let countryIdArray = [999]
      _.each(this.countries, (country) => {
        countryIdArray.push(country.id)
      })

      let countryIds = countryIdArray.join(', ')

      return axios.get(
        process.env.API_URL +
        'data/?year1=' + this.year +
        '&year2=' + this.year +
        '&crsId=' + countryIds
      )
    },

    /**
     * Grab the data needed for this page
     */
    fetchData () {
      if (this.countries.length === 0 || !this.year) {
        this.chartData = []
        this.calculateSubattributeData()
        this.calculateSubcomponentData()
        return false
      }

      this.cancel()

      this.$store.dispatch('startFetching', 'countryRegionsProfile')
      axios.all([
        this.loadProfileData()
      ], {
        cancelToken: new this.CancelToken((c) => {
          this.cancel = c
        })
      })
        .then(axios.spread((chartData) => {
          this.$store.dispatch('stopFetching', 'countryRegionsProfile')
          this.chartData = chartData.data
          this.calculateSubattributeData()
          this.calculateSubcomponentData()
        }))
        .catch((error) => {
          this.$store.dispatch('stopFetching', 'countryRegionsProfile')
          if (!axios.isCancel(error)) {
            EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
            console.log(error)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.infoOverlay {
  max-width: 715px;
}

.page-title__header {
  max-width: 655px;

  &.isSmall {
    max-width: 520px;
  }
}

.header-area {
  position: absolute;
  left: 20px;
  top: -40px;
}

.actions-wrap {
  display: flex; -js-display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/CountriesRegionsProfile.vue